import MuiTextField, { TextFieldProps } from "@material-ui/core/TextField";
import React from "react";

const divContainer = { height: "40px" };

export function TextField(props: TextFieldProps) {
  return (
    <div style={divContainer}>
      <MuiTextField
        {...props}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
      />
    </div>
  );
}

export default TextField;
